import { StyledAvatar } from "./styled";
import { IAvatarProps } from "./types";

const Avatar = (props : IAvatarProps)=>(
    <StyledAvatar {...props}/>
)

export {Avatar}